import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
} from "@mui/material";
import { Link } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import events2 from "../../assets/images/events_2.png";
import locationSmall from "../../assets/images/location-small.svg";
import userSmall from "../../assets/images/user-small.svg";
import dateSmall from "../../assets/images/date-small.svg";
import buypriceSmall from "../../assets/images/buyprice-small.svg";
import closeBtn from "../../assets/images/close.svg";
import useRequests from "../../utils/useRequests";
import { format } from "date-fns";
import Snackbars from "../../utils/Snackbars";

const events = [
  {
    id: 1,
    image: events2,
    user: "General Ticket, 1 Day Pass, 1 Person",
    title: "Raas Ratri : A Night of Dance and Devotion",
    date: "8 Oct - 18 Oct 2025, 08:00 PM - 10:00 PM",
    location:
      "123 Shree Mandir Road, Navrang Colony, Ahmedabad, Gujarat - 380001",
    ticketprice: "780.00",
    status: "Sold Out",
    transactionId: "TXN123456",
    buyer: "John Doe",
    paymentMethod: "Credit Card",
  },
  {
    id: 2,
    image: events2,
    user: "VIP Ticket, 1 Day Pass, 2 Person",
    title: "Dandiya fever",
    date: "8 Oct - 18 Oct 2025, 08:00 PM - 10:00 PM",
    location:
      "123 Shree Mandir Road, Navrang Colony, Ahmedabad, Gujarat - 380001",
    ticketprice: "780.00",
    status: "Pending",
    transactionId: "TXN789012",
    buyer: "Jane Smith",
    paymentMethod: "PayPal",
  },
];

const Myresellticketlist = () => {
  const [selectedTicket, setSelectedTicket] = useState(null);
  const { getRequest, postRequest  } = useRequests();
  const [loading, setLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);

  const handleOpen = (ticket) => {
    if (ticket.resale_status == "Sold") {
      const { formatedTransactionDate } = formatEventDate(
        ticket.start_datetime,
        ticket.end_datetime,
        ticket.start_time + " - " + ticket.end_time,
        ticket.event_ticket_date,
        ticket.transaction_date
      );
      ticket.formatedTransactionDate = formatedTransactionDate;
      setSelectedTicket(ticket);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedTicket(null);
  };

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: "",
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const [tickets, setTickets] = useState([]);
  const [bannerUrl, setbannerUrl] = useState(null);

  const fetchTickets = async () => {
    const response = await getRequest("user-resell-tickets");

    if (response && response.code === 200) {
      if(response.data.length!=0){

      const ticketsData = Array.isArray(response.data.data)
        ? response.data.data
        : [response.data.data];

      // const ValidTickets = ticketsData.filter((ticket) => ticket.quantity != 0);
      setTickets(ticketsData);
      setbannerUrl(response.data.banner);
      }
    } else {
      console.error("Failed to fetch events:", response?.message);
      setAlertData((prev) => ({
        ...prev,
        variant: "error",
        message: "Failed to fetch events",
      }));
    }
    resetAlertData();
    setLoading(false);
  };

  const [resaleId, setResaleId] = useState(false);
  const handleOpenCancelModel = async (resaleId) => {
    setResaleId(resaleId);
    setOpen1(true);
  }

  const handleCancelResale = async () => {
    setLoading(true);
    const jsonpar = JSON.stringify({
      r_id: resaleId
    });
    const response = await postRequest("cancel-resell-ticket", jsonpar);

    if (response && response.code === 200) {
      setAlertData({
        variant: "success",
        message: "Ticket resell canceled successfully.",
      });
      fetchTickets(); // Refresh tickets after cancellation
    } else {
      setAlertData({
        variant: "error",
        message: response?.message || "Failed to cancel ticket resell.",
      });
    }
  }

  React.useEffect(() => {
    fetchTickets();
  }, []);

  const formatEventDate = (start, end, time, ticketDate, transaction_date) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffInMs = endDate - startDate; // Difference in milliseconds
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24); // Convert to days
    const day = `${diffInDays + 1}`.toLowerCase();

    const startDay = format(startDate, "dd");
    const endDay = format(endDate, "dd");
    const endmonth = format(endDate, "MMMM");
    const startmonth = format(startDate, "MMMM");
    const year = format(startDate, "yyyy");
    let daysCount = day;
    if (day > 1) {
      daysCount = "10";
    }

    const ticket_date = new Date(ticketDate);
    const ticketDay = format(ticket_date, "dd");

    const transactiontDate = new Date(transaction_date);
    const transactiontDay = format(transactiontDate, "dd");
    const transactiontmonth = format(transactiontDate, "MMMM");
    const transactiontyear = format(transactiontDate, "yyyy");

    if (startDay == endDay) {
      return {
        formattedDate: `${startDay} ${startmonth} ${year}`,
        daysCount: `${daysCount} Day's Event`,
        time,
        ticketFormatedDate: `${ticketDay} ${startmonth} ${year}`,
        formatedTransactionDate: `${transactiontDay} ${transactiontmonth} ${transactiontyear}`,
      };
    }

    return {
      formattedDate: `${startDay} ${startmonth} - ${endDay} ${endmonth} ${year}`,
      daysCount: `${daysCount} Day's Event`,
      time,
      ticketFormatedDate: `${ticketDay} ${startmonth} ${year}`,
      formatedTransactionDate: `${transactiontDay} ${transactiontmonth} ${transactiontyear}`,
    };
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}
      <div className="center-App" container direction="column">
        <Header name="My Resell Ticket" />
        <Box
          sx={{
            padding: "15px",
            float: "left",
            width: "100%",
            height: "calc(100vh - 160px)",
            overflow: "auto",
          }}
        >
          {loading ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                minHeight: "300px",
              }}
            >
              <CircularProgress color="primary" />
              <p>Loading ...</p>
            </Box>
          ) : (
            <div container spacing={2}>
              {tickets.length > 0 ? (
                tickets.map((ticket) => {
                  const { formattedDate, daysCount, time, ticketFormatedDate } =
                    formatEventDate(
                      ticket.start_datetime,
                      ticket.end_datetime,
                      ticket.start_time + " - " + ticket.end_time,
                      ticket.event_ticket_date,
                      ticket.transaction_date
                    );
                  return (
                    <div item xs={12} key={ticket.r_id}>
                      <Box className="events-box">
                        <Card
                          sx={{
                            borderRadius: "10px",
                            padding: "15px",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                          }}
                        >
                          <div
                            className="position-relative radius-img-box"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <CardMedia
                              component="img"
                              height="185"
                              image={bannerUrl + ticket.banner}
                              alt={ticket.name}
                              className="small-event-img"
                            />
                            <Typography
                              variant="h6"
                              component="div"
                              sx={{
                                width: "calc(100% - 80px)",
                                color: "#6638A2",
                                marginTop: "5px",
                                fontSize: "21px",
                                marginBottom: "10px",
                                lineHeight: "27px",
                                fontWeight: "500",
                                paddingLeft: "15px",
                              }}
                            >
                              {ticket.name}
                            </Typography>
                          </div>
                          <CardContent style={{ padding: "9px 5px" }}>
                            <Typography
                              variant="body2"
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: "7px",
                                fontSize: "16px",
                                color: "#341439",
                              }}
                            >
                              <img
                                src={userSmall}
                                alt=""
                                className="small-svg"
                              />
                              <span
                                style={{ marginLeft: "5px" }}
                              >{`${ticket.type} Ticket, ${ticket.day_pass} Day Pass, ${ticket.resale_quantity} Person`}</span>
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: "7px",
                                fontSize: "16px",
                                color: "#341439",
                              }}
                            >
                              <img
                                src={dateSmall}
                                alt=""
                                className="small-svg"
                              />
                              <span style={{ marginLeft: "5px" }}>
                                {ticket.day_pass == 1
                                  ? ticketFormatedDate + ", " + time
                                  : formattedDate + ", " + time}
                              </span>
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: "7px",
                                fontSize: "16px",
                                color: "#341439",
                              }}
                            >
                              <img
                                src={buypriceSmall}
                                alt=""
                                className="small-svg"
                                style={{ width: "16px", marginLeft:"1px"}}
                              />
                               <span style={{ marginLeft: "5px" }}>
                              {` Buying Price ₹${
                                ticket.resale_quantity *
                                (Number(ticket.purchase_price) /
                                  (Number(ticket.quantity) +
                                    Number(ticket.resold_quantity)))
                              }`}
                              </span>
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: "7px",
                                fontSize: "16px",
                                color: "#341439",
                              }}
                            >
                              <img
                                src={locationSmall}
                                alt=""
                                className="small-svg"
                              />
                              <span style={{ marginLeft: "5px" }}>
                                {ticket.address}
                              </span>
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ alignItems: "center", marginTop: "7px" }}
                            >
                              <span
                                style={{
                                  color: "#028E54",
                                  fontSize: "18px",
                                  fontWeight: "500",
                                }}
                              >
                                Offer Ticket Price ₹ {ticket.resale_price}
                              </span>
                              <Link
                                onClick={() => handleOpen(ticket)}
                                style={{
                                  textDecoration: "none",
                                  position: "relative",
                                  cursor: "pointer",
                                }}
                              >
                                <span
                                  style={{
                                    float: "right",
                                    background:
                                      ticket.resale_status === "Sold"
                                        ? "#6c757d"
                                        : "#FFA500",
                                    fontSize: "15px",
                                    fontWeight: "500",
                                    borderRadius: "5px",
                                    color: "#fff",
                                    padding: "4px 9px",
                                  }}
                                >
                                  {ticket.resale_status}
                                </span>
                              </Link>
                              {ticket.resale_status === "Available" ?
                                  <Button
                                    variant="outlined"
                                    color="error"
                                    size="small"
                                    onClick={() => handleOpenCancelModel(ticket.r_id)}
                                    style={{ marginLeft: "15px" }}
                                  >
                                    Remove
                                  </Button>
                              :""}
                            </Typography>
                          </CardContent>
                        </Card>
                      </Box>
                    </div>
                  );
                })
              ) : (
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ textAlign: "center", marginTop: "20px" }}
                >
                  No tickets found.
                </Typography>
              )}
            </div>
          )}
        </Box>
        <Footer />

        {/* Transaction Details Dialog */}
        <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
          <DialogTitle>Transaction details</DialogTitle>
          <Button onClick={handleClose} className="close-btn">
            <img src={closeBtn} alt="" />
          </Button>
          <DialogContent dividers>
            {selectedTicket && (
              <>
                <Typography variant="body1">
                  <strong>Buyer Name: </strong>{" "}
                  {selectedTicket.buyer_first_name +
                    " " +
                    selectedTicket.buyer_last_name}
                </Typography>
                <Typography variant="body1">
                  <strong>Quantity : </strong> {selectedTicket.resale_quantity}
                </Typography>
                <Typography variant="body1">
                  <strong>Amount : </strong> ₹{selectedTicket.resale_price}
                </Typography>
                <Typography variant="body1">
                  <strong>Date : </strong>{" "}
                  {selectedTicket.formatedTransactionDate}
                </Typography>
                <Typography variant="body1">
                  <strong>Payment ID : </strong>{" "}
                  {selectedTicket.resale_payment_id}
                </Typography>
              </>
            )}
          </DialogContent>
        </Dialog>

        <Dialog open={open1} onOpenChange={setOpen1}>
          <div
            className="install-modal"
            style={{
              zIndex: 111,
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0, 0, 0, 0.7)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                background: "white",
                padding: "25px 10px 30px",
                borderRadius: "10px",
                textAlign: "center",
                width: "100%",
                maxWidth: "430px",
                margin: "0 10px",
              }}
            >
              <p style={{ fontSize: "20px", marginTop: "8px" }}>
                Are you sure you want to remove this ticket from resell market?
              </p>
              <button
                id="submit1"
                onClick={(e) => {
                  e.preventDefault();
                  setOpen1(false);
                  handleCancelResale();
                  return false;
                }}
                style={{
                  background: "#6638A2",
                  border: "none",
                  padding: "4px 25px",
                  fontSize: "18px",
                  color: "#fff",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Remove
              </button>
              <button
                onClick={() => setOpen1(false)}
                style={{
                  marginLeft: "10px",
                  background: "#EFEFEF",
                  border: "none",
                  padding: "4px 25px",
                  fontSize: "18px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </Dialog>
      </div>
    </Box>
  );
};

export default Myresellticketlist;
